<template src="@/templates/reservations/documents.html"></template>

<script>
import userApi from '@/api/userApi';
import entityStore from '@/store/entityStore';
import { restEndpoint } from '@/config.json';
import userAuthStore from '@/store/userAuthStore';
import voucherList from '@/components/reservations/voucher-list';

export default {
  props: [
    'reservationId',
    'reservation',
  ],
  data() {
    return {
      isLoading: true,
      travelDocuments: [],
      passengers: [],
      token: userAuthStore.state.token,
    };
  },
  computed: {
    downloadUrl() {
      return `${restEndpoint}/reservation/${this.reservationId}/travel-document/download`;
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      userApi.getTravelDocuments(this.reservationId, (data) => {
        this.travelDocuments = data.travelDocuments;
        this.isLoading = false;
      });
      userApi.getPassengers(this.reservationId, (data) => {
        this.passengers = data.passengers;
        this.isLoading = false;
      });
    },
    formatName(passenger) {
      if (entityStore.state.name === 'amigo') {
        return `${passenger.salutation} ${passenger.initials} ${passenger.middlename} ${passenger.lastname}`;
      }
      return `${passenger.salutation} ${passenger.initials} ${entityStore.formatPassengerName(passenger)}`;
    },
    downloadTravelDocument(travelDocument) {
      userApi.downloadTravelDocument(this.reservationId, travelDocument);
    },
    downloadPassengerDocument(passenger, document) {
      userApi.downloadPassengerDocument(this.reservationId, passenger.id, document);
    },
  },
  components: {
    voucherList,
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// documents.vue?f1b1a1a2